// extracted by mini-css-extract-plugin
module.exports = {"landing_page_cont":"styles_landing_page_cont__M9lIR","view_more_btn":"styles_view_more_btn__SYKUt","section_heading":"styles_section_heading__nFGEA"};